import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Buttons, Spacer, boxContainer, questionnaireComponents } from "..";

import "./styles.css";

const Facilities = ({ setPage }) => {
  const questionnaire = useSelector(
    (state) => state?.students?.student?.profileBuilder
  );

  const [state, setState] = useState({
    uniAcommodationImportance: "",
    uniTransportImportance: "",
  });

  useEffect(() => {
    setState({
      uniAcommodationImportance: questionnaire?.uniAcommodationImportance ?? "",
      uniTransportImportance: questionnaire?.uniTransportImportance ?? "",
    });
  }, [questionnaire]);

  return (
    <boxContainer.LiteBoxContainer>
      <questionnaireComponents.QuestionnaireLabel
        text="1. How important is university accommodation for you?"
        required
      />
      <Spacer height="0.625em" />
      <questionnaireComponents.QuestionnaireCircleInput
        value={state?.uniAcommodationImportance}
      />
      <Spacer height="1.5em" />
      <questionnaireComponents.QuestionnaireLabel
        text="2. How important is it for the university to have their own transport
             service?"
        required
      />
      <Spacer height="0.625em" />
      <questionnaireComponents.QuestionnaireCircleInput
        value={state?.uniTransportImportance}
      />
      <Spacer height="1.25em" />
      <div className="flex justify-end">
        <div className="w-[12.5em]">
          <Buttons.DefaultButton
            size="large"
            width="full"
            onClick={() => setPage("Demographics")}
          >
            Next
          </Buttons.DefaultButton>
        </div>
      </div>
    </boxContainer.LiteBoxContainer>
  );
};

export default Facilities;
